import { render, staticRenderFns } from "./SSelectAssigned.vue?vue&type=template&id=b62fba02"
import script from "./SSelectAssigned.vue?vue&type=script&lang=js"
export * from "./SSelectAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports